import { createAsyncThunk } from "@reduxjs/toolkit";
import { MARKETING } from "constants/api";
import axios from "utils/http";

export interface IRedemptionListResponse extends ApiResponse {
  data: IVoucherRedemptionList;
}

export interface IFetchRedemptionsArgs extends ReduxAction {
  page: number;
  queries: Record<string, string | undefined>;
}

export const fetchRedemptions = createAsyncThunk(
  MARKETING.REDEMPTIONS,
  async (
    { page, queries, onFailure }: IFetchRedemptionsArgs,
    { rejectWithValue }
  ) => {
    try {
      const params = Object.entries(queries).reduce<Record<string, string | number>>(
        (all, [key, value]) => {
          if (value) all[key] = value;
          return all;
        },
        { page }
      );

      const { data }: IRedemptionListResponse = await axios.get(
        MARKETING.REDEMPTIONS,
        { params }
      );

      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
